import { createSlice, PayloadAction } from "@reduxjs/toolkit";

const initialState = null;

const checkIfAuthenticatedSlice = createSlice({
  name: "checkIfAuthenticated",
  initialState,
  reducers: {
    setCheckIfAuthenticated: (_state: any, action: PayloadAction<any>) => action.payload,
  },
});

export const { setCheckIfAuthenticated } = checkIfAuthenticatedSlice.actions;
export default checkIfAuthenticatedSlice.reducer;
